module.exports = __webpack_public_path__ + "static/media/Comfortaa-Bold.f513c4ce.woff";